<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
          title="Edit"
        >
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="primary"
      style="margin-bottom:0"
    >
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              Payment Channel
            </h4>
            <p class="category font-weight-thin">
              Edit Payment Channel
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>
      <v-form
        v-if="dialog && !loading"
      >
        <v-container>
          <v-row>
            <v-col class="title">
              {{ branchPaymentChannel.branch_name }}
            </v-col>
          </v-row>
          <div
            class="overflow"
            data-simplebar
          >
            <!-- <v-row>
              <v-col>
                <v-data-table
                  v-model="selectedPaymentChannels"
                  dense
                  :headers="headers"
                  :items="paymentChannels"
                  hide-default-footer
                  fixed-header
                  disable-pagination
                  item-key="id"
                  item-value="id"
                  show-select
                  sort-by="company.name"
                  class="elevation-1 mb-3"
                  height="335px"
                  :search="search"
                >
                  <template v-slot:top>
                    <v-toolbar
                      flat
                    >
                      <v-row>
                        <v-col class="col">
                          <v-toolbar-title>
                            Select at least one Payment Channel:
                          </v-toolbar-title>
                        </v-col>
                        <v-col class="col">
                          <v-text-field
                            v-model="search"
                            label="Search"
                            append-icon="search"
                          />
                        </v-col>
                      </v-row>
                    </v-toolbar>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span
                  v-show="paymentChannelError"
                  class="red--text"
                > 
                  Must have at least one payment channel!
                </span>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col>
                <div>
                  <span v-show="selectedPaymentChannels.length > 0"> Branch Account </span>
                  <v-radio-group
                    v-model="selectedBranchAccount"
                    v-validate="{
                      accountTaken: selectedPaymentChannels
                    }"
                    :error-messages="errors.collect('branchAccount')"
                    data-vv-name="branchAccount"
                  >
                    <v-radio
                      v-for="(paymentChannel, index) in selectedPaymentChannels"
                      :key="index"
                      :label="paymentChannel.combined"
                      :value="index"
                      :disabled="!accountTaken(index, selectedPaymentChannels)"
                    />
                  </v-radio-group>
                </div>
              </v-col>
            </v-row>
                    
            <v-card-actions>
              <v-spacer />
              <v-btn
                :loading="progressing"
                color="success"
                @click="submitForm"
              >
                Update
              </v-btn>
            </v-card-actions>
          </div>
        </v-container>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      branchPaymentChannel: Object,
    },

    data () {
      return {
        dialog: false,
        loading: false,
        progressing: false,
        paymentChannelError: false,

        accountUid: '',

        branches: [],
        branchAccounts: [],
        paymentChannels: [],
        selectedPaymentChannels: [],
        selectedBranchAccount: '',
        search: '',
        headers: [
          { text: 'Company', value: 'company.name', align: 'left' },
          { text: 'Type', value: 'payment_channel_type.name', align: 'left' },
          { text: 'Bank', value: 'bank.name', align: 'left' },
          { text: 'Reference No', value: 'reference', align: 'left' },
        ],
      }
    },
    watch: {
      dialog (value) {
        if (!value) {
          this.$validator.pause()
          this.$resetData()
        } else {
          this.loadData()
          this.$validator.resume()
        }
      },
    },
    mounted () {
    },
    methods: {
      loadData () {
        this.loading = true
        Promise.all([
          this.$api.paymentChannels().list(),
          this.$api.branchPaymentChannels().show(this.branchPaymentChannel.branch_uid),
          this.$api.branchPaymentChannels().showBranchAccount(),
        ]).then(([paymentChannels, branchPaymentChannels, branchAccounts]) => {
          paymentChannels.data.map(paymentChannel => {
            if (paymentChannel.bank) {
              if (paymentChannel.type_id === 2) {
                paymentChannel.combined = `${paymentChannel.company.name} - ${paymentChannel.payment_channel_type.name} (${paymentChannel.bank.name})`
              } else {
                paymentChannel.combined = `${paymentChannel.company.name} - ${paymentChannel.payment_channel_type.name} (${paymentChannel.bank.name} - ${paymentChannel.reference})`
              }
            } else {
              paymentChannel.combined = `${paymentChannel.company.name}-${paymentChannel.payment_channel_type.name}`
            }
            branchPaymentChannels.data.map(branchPaymentChannel => {
              if (paymentChannel.id === branchPaymentChannel.payment_channel_id) {
                this.selectedPaymentChannels.push(paymentChannel)
              }
              if (branchPaymentChannel.acct_uid !== null) {
                this.accountUid = branchPaymentChannel.acct_uid
              }
            })
          })
          this.branchAccounts = branchAccounts.data.filter(branchAccount => {
            return branchAccount.branch_uid !== this.branchPaymentChannel.branch_uid
          })
          this.paymentChannels = paymentChannels.data
          this.selectedBranchAccount = branchPaymentChannels.data.findIndex(branchPaymentChannel => 
            branchPaymentChannel.acct_uid !== null,
          )
          this.loading = false
          this.$validator.resume()

          const scope = this
          this.$validator.extend('accountTaken', {
            getMessage (field, args) {
              return 'The payment channel has been assigned as branch payment account by other branch'
            },
            validate (value, args) {
              return scope.accountTaken(value, args)
            },
          })
        })
      },
      accountTaken (value, args) {
        const paymentChannelId = args[value].id
        const found = this.branchAccounts.some(branchAccount => {
          return branchAccount.payment_channel_id === paymentChannelId
        })
        return !found
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            if (this.selectedPaymentChannels.length > 0) {
              this.progressing = true
              this.$api.branchPaymentChannels().update(this.branchPaymentChannel.branch_uid, this.prepareFormData())
                .then((response) => {
                  if (response.status === 200) {
                    this.$emit('updated')
                    this.$snack({ color: 'success', message: 'Branch Payment Channel has been updated successfully' })

                    this.dialog = false
                  }
                }).catch(err => {
                  console.log(err)
                  let errorMessage = ''
                  if (err.response.status === 404) {
                    errorMessage = err.response.data.message
                  } else {
                    errorMessage = err.response.statusText
                  }
                  this.$snack({ color: 'error', message: errorMessage })
                }).then(() => {
                  this.progressing = false
                })
            } else { this.paymentChannelError = true }
          })
      },
      prepareFormData () {
        const paymentChannels = []
        this.selectedPaymentChannels.map((paymentChannel, index) => {
          let selected = false
          if (index === this.selectedBranchAccount) {
            selected = true
          }

          const tempPaymentChannel = {
            payment_channel_id: paymentChannel.id,
            selected_branch_payment_channel: selected,
          }
          paymentChannels.push(tempPaymentChannel)
        })
        return paymentChannels
      },
    },
  }
</script>
<style>
  .overflow {
    height: 60vh;
    overflow-x: hidden;
  }

  .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
    background-image: linear-gradient( grey , grey);
  }
</style>
